import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/src/app/_components/ui/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/lib/translation/components/link/index.tsx");
